module.exports = __webpack_public_path__ + "static/media/kingsarcade.e92d4b76.jpg";